import {API_BASE_URL} from "../config/api";
import {RoundTripFlight} from "../models/RoundTripFlight";

export interface SharedFlight {
  flight: RoundTripFlight;
  created_at: number;
  expires_at: number;
}

export class SharedFlightService {
  static async create(flight: RoundTripFlight): Promise<string> {
    const response = await fetch(`${API_BASE_URL}/shared-flights`, {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({flight}),
    });
    if (!response.ok) throw new Error("Could not create flight link");
    const {id} = await response.json();
    return `${window.location.origin}/flights/shared/${encodeURIComponent(id)}`;
  }

  static async get(id: string): Promise<SharedFlight> {
    const response = await fetch(`${API_BASE_URL}/shared-flights/${encodeURIComponent(id)}`);
    if (!response.ok) throw new Error("Shared flight unavailable");
    return response.json();
  }
}
